<template>
  <div
    class="ad-page"
    @click="handleClick"
  >
    <img
      src="@/assets/img/chargingVoucher/ad-page-bg.jpg"
      class="ad-page-bg"
    >
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {};
  },
  methods: {
    handleClick() {
      const a = this.$route.query?.a || '';

      window.location.href = `https://mppbi.cias.cn/index.html?a=${a}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.ad-page {
  width: 100vw;
  overflow-x: hidden;

  .ad-page-bg {
    width: 100%;
    object-fit: contain;
  }
}
</style>
